export default __webpack_public_path__ + "static/media/man-head-icon-3.552bc0cc.svg";